import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }

import {onMounted, onUnmounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import SidebarComponent from "@/components/SidebarComponent.vue";
import FooterImpressum from "@/components/FooterImpressum.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

watch(
    () => route.meta.title,
    (title) => {
      document.title = title as string || "Dachdecke Firmenname";
    }
);

const isMobile = ref(window.innerWidth <= 1600);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 1600;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarComponent),
    _createVNode(_component_RouterView),
    _createVNode(FooterImpressum)
  ]))
}
}

})